(()=>{
'use strict';
function init(root){
  if(!root||root.dataset.ready==='1')return;
  root.dataset.ready='1';
  const panels=[...root.querySelectorAll('[data-recipe-panel]')];
  const tabs=[...root.querySelectorAll('[data-recipe-tab]')];
  const stickyPrice=root.querySelector('[data-mm-sticky-price]');
  const stickyAdd=root.querySelector('[data-mm-sticky-add]');
  const stickyBuy=root.querySelector('[data-mm-sticky-buy]');
  const shopRoot=window.Shopify?.routes?.root||'/';
  const isAr=(root.dir||document.documentElement.dir)==='rtl'||(document.documentElement.lang||'').toLowerCase().startsWith('ar');
  let active=null,controller=null,purchasePending=false;
  const money=new Intl.NumberFormat(isAr?'ar-EG':'en-EG',{style:'currency',currency:'EGP',maximumFractionDigits:0});
  const format=c=>money.format((Number(c)||0)/100);
  const panelFor=k=>panels.find(p=>p.dataset.recipePanel===k);
  const setPanelBusy=(panel,busy)=>panel.querySelectorAll('[data-mm-add],[data-mm-buy]').forEach(b=>b.disabled=busy||panel.dataset.available!=='true');
  const syncSticky=()=>{const unavailable=!active||active.dataset.available!=='true';if(stickyAdd)stickyAdd.disabled=purchasePending||unavailable;if(stickyBuy)stickyBuy.disabled=purchasePending||unavailable;};
  const setPurchaseBusy=busy=>{purchasePending=busy;panels.forEach(p=>setPanelBusy(p,busy));syncSticky();};
  const updateSticky=()=>{if(!active)return;const price=active.querySelector('[data-recipe-price]')?.textContent?.trim();if(price&&stickyPrice)stickyPrice.textContent=price;syncSticky();};

  async function resolve(panel){
    controller?.abort();controller=new AbortController();
    const ids=[...panel.querySelectorAll('[data-option-select]')].map(s=>s.value).filter(Boolean);
    const status=panel.querySelector('[data-recipe-status]');
    status.textContent=root.dataset.updating||'';status.classList.remove('is-error');setPanelBusy(panel,true);if(panel===active)syncSticky();
    try{
      const url=new URL(panel.dataset.productUrl,location.origin);url.searchParams.set('option_values',ids.join(','));
      const response=await fetch(url.toString(),{credentials:'same-origin',signal:controller.signal});if(!response.ok)throw new Error('selection-load-failed');
      const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
      const script=parsed.querySelector('variant-selects script[data-selected-variant], script[data-selected-variant]');
      const variant=script?.textContent?.trim()?JSON.parse(script.textContent):null;
      if(!variant){panel.dataset.variantId='';panel.dataset.available='false';status.textContent=root.dataset.unavailable||'';status.classList.add('is-error');setPanelBusy(panel,false);if(panel===active)syncSticky();return;}
      panel.dataset.variantId=variant.id||'';panel.dataset.available=variant.available?'true':'false';
      if(typeof variant.price!=='undefined')panel.querySelector('[data-recipe-price]').textContent=format(variant.price);
      const compare=panel.querySelector('[data-recipe-compare]');
      if(compare){if(variant.compare_at_price&&variant.compare_at_price>variant.price){compare.hidden=false;compare.textContent=format(variant.compare_at_price)}else{compare.hidden=true;compare.textContent=''}}
      status.textContent=variant.available?'':(root.dataset.unavailable||'');status.classList.toggle('is-error',!variant.available);setPanelBusy(panel,false);if(panel===active)updateSticky();
    }catch(error){if(error.name==='AbortError')return;panel.dataset.available='false';status.textContent=root.dataset.error||'';status.classList.add('is-error');setPanelBusy(panel,false);if(panel===active)syncSticky();}
  }

  function activate(key){
    if(purchasePending)return;
    const panel=panelFor(key)||panels[0];if(!panel)return;active=panel;
    panels.forEach(p=>{const on=p===panel;p.hidden=!on;p.classList.toggle('is-active',on)});
    tabs.forEach(t=>{const on=t.dataset.recipeTab===panel.dataset.recipePanel;t.classList.toggle('is-active',on);t.setAttribute('aria-selected',on?'true':'false')});
    const url=new URL(location.href);url.searchParams.set('recipe',panel.dataset.recipePanel);history.replaceState({},'',url);updateSticky();resolve(panel);
  }

  async function reconcile(){
    if(window.__unoGiftCapReady&&typeof window.__unoGiftCapReady.then==='function')await window.__unoGiftCapReady;
    if(window.UnoGiftCap&&typeof window.UnoGiftCap.reconcile==='function')await window.UnoGiftCap.reconcile();
  }
  async function evaluateShipping(url){
    const shipping=window.UnoShippingUpgrade;
    if(!shipping||typeof shipping.evaluateFreeShippingBeforeCheckout!=='function')return true;
    return shipping.evaluateFreeShippingBeforeCheckout({checkoutUrl:url,reconcileFirst:false});
  }

  async function add(panel,checkout){
    if(purchasePending||!panel?.dataset.variantId||panel.dataset.available!=='true')return;
    setPurchaseBusy(true);
    const status=panel.querySelector('[data-recipe-status]');status.classList.remove('is-error');
    const target=`${shopRoot}${checkout?'checkout':'cart'}`;
    try{
      const response=await fetch(`${shopRoot}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:Number(panel.dataset.variantId),quantity:1,properties:{'_UNO Mix & Match':panel.dataset.productTitle}}]})});
      const payload=await response.json().catch(()=>null);if(!response.ok||payload?.status)throw new Error(payload?.description||payload?.message||root.dataset.error);
      await reconcile();status.textContent=root.dataset.added||'';
      if(!checkout){location.assign(target);return;}
      const proceed=await evaluateShipping(target);
      if(proceed){location.assign(target);return;}
      setPurchaseBusy(false);
    }catch(error){status.textContent=error?.message||root.dataset.error||'';status.classList.add('is-error');setPurchaseBusy(false);}
  }

  tabs.forEach(t=>t.addEventListener('click',()=>activate(t.dataset.recipeTab)));
  panels.forEach(p=>{p.querySelectorAll('[data-option-select]').forEach(s=>s.addEventListener('change',()=>resolve(p)));p.querySelector('[data-mm-add]')?.addEventListener('click',()=>add(p,false));p.querySelector('[data-mm-buy]')?.addEventListener('click',()=>add(p,true));});
  stickyAdd?.addEventListener('click',()=>add(active,false));
  stickyBuy?.addEventListener('click',()=>add(active,true));
  const wanted=new URL(location.href).searchParams.get('recipe');activate(panelFor(wanted)?wanted:(panels[0]?.dataset.recipePanel||'fresh'));
}
function boot(scope=document){scope.querySelectorAll?.('.uno-mm-v3[data-uno-mm-v4]').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();
document.addEventListener('shopify:section:load',e=>boot(e.target));
})();
